import React, { Component } from "react";
import { Link } from "react-router-dom";
import BackendClient from "../../BackendClient";
// import { yyyyddmm } from "../../helpers/dateType";
import Loading from "../../Components/Loading";

export default class News extends Component {
  state = {
    isFetched: false,
    isFetching: false,
    hasError: false
  };

  componentDidMount() {
    const { isFetching, isFetched, hasError } = this.state;
    if (!(isFetched && isFetching && hasError)) {
      this.setState({ isFetching: true });
      BackendClient.getNews({ sort: "-published_at" })
        .fetchJson()
        .then(res => {
          if (res) {
            const options = {
              month: "long",
              day: "numeric",
              year: "numeric"
            };

            const items = (res.items || []).map(item => {
              const date = new Date(item.published_at * 1000);
              return Object.assign(item, {
                published_at: date.toLocaleString("ru", options),
                date: date.yyyyddmm()
              });
            });
            return this.setState({
              isFetching: false,
              isFetched: true,
              items
            });
          }
          return this.setState({
            hasError: true,
            isFetched: true,
            errorMessage: "Fetch error"
          });
        });
    }
  }

  render() {
    let content;
    const { isFetched, isFetching, hasError, errorMessage, items } = this.state;
    if (isFetched) {
      if (hasError) {
        content = <span className="text-error">{errorMessage}</span>;
      } else {
        content = items.slice(0, 3).map((newsItem, idx) => (
          <li>
            <Link key={`linkNews${idx}`} to={`/news/${newsItem.id}`}>
              <div className="date">{newsItem.published_at}</div>
              <div
                className="preview"
                dangerouslySetInnerHTML={{ __html: newsItem.title }}
              />
            </Link>
          </li>
        ));
      }
    } else if (isFetching) {
      content = <Loading loading />;
    }
    return (
      <div className="news-wrapper">
        <div className="container">
          <h4 className="news-title">Новости</h4>
          <ul className="news-block">{content}</ul>
          <Link to="/news" className="btn-border-black news-link">
            Все новости
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/main/news.jsx